/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    .Toastify__toast--warning {
        background-color: #F0B01B;
    }

    .Toastify__toast--success {
        background: ${({ theme }) => theme.colors.lightGreen};
        color: ${({ theme }) => theme.colors.purple};
        font-weight: bold;
    }

    .ds-toast.Toastify__toast {
        background: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        min-height: 0 !important;
        color: inherit !important;
        font-weight: normal !important;
    }

    .ds-toast .Toastify__toast-body {
        padding: 0 !important;
        margin: 0 !important;
    }

    .ds-toast .Toastify__progress-bar {
        display: none !important;
    }

    .Toastify__toast-container--top-right .ds-toast {
        margin-right: 96px;
        width: max-content;
        max-width: min(560px, calc(100vw - 128px));
    }

    body {
        background-color: #F5F5F5;
        -webkit-font-smoothing: antialiased;
        font-family: 'Mangueira', sans-serif !important;
    }

    button {
        cursor: pointer;
    }

    @media (max-width: 640px) {
        .modal-dialog {
            margin: 1.1rem auto;
        }
    }

    .introjs-tooltip {
        border-radius: 11px !important;
        padding: 21px 20px 12px 20px !important;
        * {
            outline: none;
        }
        h5 {
            color: #328CFD;
            font-size: 16px;
        }
        p {
            font-size: 14px;
            margin-bottom: 0px;
        }
    }
    .introjs-helperLayer {
        border-radius: 10px !important;
    }
    .elm-intro-usermenu {
        margin-top: -8px;
        padding-right: 9px !important;
        @media (min-width: 1400px) {
            width: 84.8% !important;
        }
    }
    .introjs-prevbutton,
    .introjs-nextbutton {
        display: none !important;
    }
    .introjs-skipbutton {
        position: absolute !important;
        top: 0 !important;
        right: 1px !important;
        margin-right: 10px !important;
        margin-top: 11px !important;
        border: none !important;
        background: #fff !important;
        padding: 0px !important;
        font-size: 16px !important;
        &:hover {
            box-shadow: none !important;
        }
    }
    .introjs-bullets ul li a.active {
        width: 23px;
    }
    .elm-intro-navbar {
        top: -10px !important;
        box-shadow: none !important;
        border: none !important;
        background-color: transparent !important;
    }
    .tol-intro-navbar {
        margin-top: 35vh;
    }

    .elm-intro-burger {
        background: #A540E3 !important;
        opacity: .21 !important;
        height: 50px !important;
        width: 54px !important;
    }

    #indecx-widget-content {
      max-width: 672px !important;
      padding: 20px !important;
    }

    .basic-single {
      font-size: 62.5% !important;
    }

    @keyframes spinerAnimate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
